module.exports = __webpack_public_path__ + "static/media/icon_ren0c37877b93d1b03d094d95b2b6892978.webp";